import React from 'react';

// Clean modern menu card (no stamp effect). Black & white, keeps character with typography.
const MenuCard = ({ image, fallback, label, onClick, buttonLabel = 'Seleziona' }) => {
  return (
    <button
      onClick={onClick}
      className="group block w-full text-left thin-frame overflow-hidden outline-none focus-visible:ring-2 focus-visible:ring-black focus-visible:ring-offset-2 active:scale-[0.98] transition-transform"
    >
      <div className="relative overflow-hidden bg-black/5" style={{ aspectRatio: '4/5' }}>
        <img
          src={image}
          alt={label}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.05]"
          loading="lazy"
          decoding="async"
          onError={(e) => { if (fallback && e.currentTarget.src !== fallback) e.currentTarget.src = fallback; }}
        />
      </div>
      <div className="px-3 py-3 md:px-5 md:py-4 h-[60px] md:h-auto flex items-center justify-between gap-2 border-t-[1.5px] border-black">
        <h3 className="font-display text-[15px] md:text-2xl leading-tight text-black line-clamp-2">
          {label}
        </h3>
        <span className="inline-flex items-center gap-1 text-[10px] md:text-sm font-bold text-black opacity-80 group-hover:opacity-100 transition whitespace-nowrap">
          <span className="hidden sm:inline">{buttonLabel}</span>
          <span aria-hidden style={{ transition: 'transform 240ms' }} className="inline-block group-hover:translate-x-1">→</span>
        </span>
      </div>
    </button>
  );
};

export default MenuCard;
